module.exports = __webpack_public_path__ + "static/media/22904586_1638429569565561_2023926200305766087_o.956ee889.jpg";